import * as Immutable from 'immutable';
import moment from "moment-timezone";
import {headerWithCredentials, ruleServerUrl} from 'configs/rule-server';
import customerInterestsService from '../../../services/customer-interests-service'
import campaignService from '../../../services/campaigns-service.js'
import {LOAD_WALK_IN_INTEREST_FORM, SELECTED_COLUMN_VALUES} from '../../WalkInInterests/modules/walkInInterests'
import walkInInterestsService from '../../../services/walk-in-interests-service'

// ------------------------------------
// Constants
// ------------------------------------
export const SET_CUSTOMER_INTERESTS_FILTER = 'SET_CUSTOMER_INTERESTS_FILTER';
export const LOAD_CUSTOMER_INTERESTS = 'LOAD_CUSTOMER_INTERESTS';
export const LOAD_STORE_OPTIONS = 'LOAD_STORE_OPTIONS'
export const LOAD_ENDLESS_AISLE_INTEREST_FORM = 'LOAD_ENDLESS_AISLE_INTEREST_FORM'
export const SELECTED_ENDLESS_AISLE_COLUMN_VALUES = 'SELECTED_ENDLESS_AISLE_COLUMN_VALUES'

// ------------------------------------
// Actions
// ------------------------------------

// ------------------------------------
// Action Handlers
// ------------------------------------

export function setCustomerInterestsFilter(filter) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_CUSTOMER_INTERESTS_FILTER,
      filter: filter
    })
  }
}

export function loadCustomerInterests(filter) {
  return (dispatch, getState) => {
    return customerInterestsService.getCustomerInterests(filter)
      .then(function (customerInterests) {
        dispatch({
          type: LOAD_CUSTOMER_INTERESTS,
          customerInterests: Immutable.fromJS(customerInterests)
        });
      });

  }
}

export function loadStoreOptions () {
  return (dispatch, getState) => {
    return campaignService.getStores().then((stores) => {
      let options = stores.map(store => {
        return {label: store.store, value: store.store}
      })
      dispatch({
        type: LOAD_STORE_OPTIONS,
        storeOptions: options
      })
    })
  }
}
export function loadEndlessAisleInterestForm () {
  return (dispatch, getState) => {
    return walkInInterestsService.getEndlessAisleForm()
      .then(function (endlessAisleInterestForm) {
        dispatch({
          type: LOAD_ENDLESS_AISLE_INTEREST_FORM,
          endlessAisleInterestForm: endlessAisleInterestForm
        })
      })
  }
}
export function selectedEndlessAisleInterestColValues (payload) {
  return (dispatch, getState) => {
    dispatch({
      type: SELECTED_ENDLESS_AISLE_COLUMN_VALUES,
      selectedEndLessAisleColumns: payload
    })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

let defaultFilter = Immutable.fromJS({
  startDate: moment().subtract(2, 'days').toDate(),
  endDate: moment().toDate(),
  storeNames: []
});

export function customerInterestsFilterReducer(state = defaultFilter, action) {
  switch (action.type) {
    case SET_CUSTOMER_INTERESTS_FILTER: {
      return action.filter
    }
    default:
      return state
  }
}

let defaultCustomerInterests = Immutable.fromJS({
  likes: [],
  wishes: []
});

export function customerInterestsReducer(state = defaultCustomerInterests, action) {
  switch (action.type) {
    case LOAD_CUSTOMER_INTERESTS: {
      return action.customerInterests
    }
    default:
      return state
  }
}

export function loadStoreOptionsReducer (state = [], action) {
  switch (action.type) {
    case LOAD_STORE_OPTIONS: {
      return action.storeOptions
    }
    default:
      return state
  }
}
let defaultEndlessAisleForm = {}
export function endlessAisleFormReducer (state = defaultEndlessAisleForm, action) {
  switch (action.type) {
    case LOAD_ENDLESS_AISLE_INTEREST_FORM: {
      return action.endlessAisleInterestForm
    }
    default:
      return state
    }
}
export function selectedEndlessAisleColValuesReducer (state = [], action) {
  switch (action.type) {
    case SELECTED_ENDLESS_AISLE_COLUMN_VALUES: {
      return action.selectedEndLessAisleColumns
    }
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/routes/CustomerInterests/modules/customerInterests.js